/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_UpInputs */

const cs_billing_top_up = /** @type {(inputs: Billing_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobít osobní kredity`)
};

const en_billing_top_up = /** @type {(inputs: Billing_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top up personal`)
};

/**
* | output |
* | --- |
* | "Top up personal" |
*
* @param {Billing_Top_UpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up = /** @type {((inputs?: Billing_Top_UpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_UpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up(inputs)
	return cs_billing_top_up(inputs)
});